<!-- DEPRECATED -->

<template>
  <b-modal
    id="notification-send-modal"
    ref="notificationSendModal"
    title="Send New Notification"
    hide-footer
    size="xl"
    @shown="onShow"
    @hidden="resetData">
    <div class="notification-send-form">
      <div
        v-show="hasTemplateMessages"
        class="settings-form">
        <b-col
          md="12"
          lg="7"
          class="px-0 float-left">
          <b-form-group>
            <label
              class="col-form-label pt-0">
              Contacts
            </label>
            <ContactSearch
              ref="contactSearch"
              v-model="bulkIds"
              v-validate="'checkBulk'"
              data-vv-name="contact_id"
              data-vv-validate-on="input"
              :fixed="fixed"/>
            <span
              v-if="errors.has('contact_id')"
              class="validation-error">{{ errors.first('contact_id') }}</span>
          </b-form-group>
          <!-- <b-form-group>
            <label
              class="col-form-label pt-0">
              Template
            </label>
            <b-select
              v-model="selectedTemplateKeyword"
              :options="templateKeywords"
              name="template"
              placeholder="Select Template"/>
          </b-form-group> -->
          <b-form-group>
            <label
              class="col-form-label pt-0">
              Language
            </label>
            <b-select
              v-model="selectedTemplateLanguage"
              placeholder="Select Template Language">
              <option
                v-for="language in languageList"
                :key="language"
                :value="language">
                {{ getLanguageName(language) }}
              </option>
            </b-select>
          </b-form-group>
          <b-form-group>
            <label
              class="col-form-label pt-0">
              Message
            </label>
            <div
              :class="{'text-arabic': selectedTemplateLanguage === 'ar'}"
              class="textarea-emit form-control"
              disabled>
              <MessageContent
                :content="selectedTemplate.text || ''"/>
            </div>
          </b-form-group>
          <b-form-group
            v-for="tag in selectedTemplate.tags"
            :key="tag"
            class="tags-group">
            <label
              class="col-form-label pt-0 text-lowercase">
              {{ tag }}
            </label>
            <b-input
              :ref="`tagArea-${tag}`"
              v-model="tagsToSend[tag]"
              v-validate="'required'"
              data-vv-validate-on="input"
              :name="tag"
              rows="3"
              class="fixed"/>
            <span
              v-if="errors.has(tag)"
              class="validation-error">{{ errors.first(tag) }}</span>
            <div
              class="editor-tools clearfix">
              <div
                v-click-outside="hideTagsList"
                class="editor-tag-list c-dropdown">
                <span
                  class="add-tag"
                  @click="toggleTagsList(`tagArea-${tag}`)">
                  <icon
                    width="12"
                    height="12"
                    name="plus"/> Add a tag
                </span>
                <div
                  v-show="showTagsList[`tagArea-${tag}`]"
                  class="c-dropdown-list settings-list">
                  <div
                    class="c-dropdown-close"
                    @click="hideTagsList">
                    <icon name="times"/>
                  </div>
                  <div class="c-dropdown-items">
                    <div
                      v-for="notificationTag in normalizedNotificationTags"
                      :key="notificationTag.keyword"
                      class="c-dropdown-item"
                      @click="setTag(notificationTag, `tagArea-${tag}`)">
                      <span>
                        {{ notificationTag.name }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group v-if="selectedTemplate.attachment">
            <label
              class="col-form-label pt-0">
              File Attachment
            </label>
            <DropZone
              v-if="!files.length && !sendAgainFile"
              :extensions="['jpg', 'jpeg', 'png', 'aac', 'm4a', 'amr', 'mp3', 'ogg', 'mp4', '3gpp', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx']"
              ref="dropZone"
              v-model="files"
              @dropped-in="fileDropped"/>
            <a
              v-if="sendAgainFile"
              :href="sendAgainFile"
              target="_blank"
              style="display: block;">
              {{ getMediaName(sendAgainFile) }}
            </a>
            <div
              v-for="(file) in files"
              :key="file.name"
              class="drop-file-list">
              <span>
                <span class="strong">{{ file.name }}</span> ({{ file.size | bytes }})
              </span>
              <b-icon
                icon="x"
                @click="clearFile(file.name)"/>
            </div>
          </b-form-group>
          
          <div class="clearfix"/>

          <p
            v-if="!fixed"
            class="unique-info">
            Total selected contacts:
            <span
              v-if="!calculatingUniqueContacts"
              :class="{ 'text-danger': uniqueContactsCount > whatsappBulkSendTemplateMessageLimit.data.limit }">
              {{ uniqueContactsCount }}</span>
            <span
              v-if="calculatingUniqueContacts"
              class="loader unique">
              <span class="loading-circle"/>
            </span>/{{ whatsappBulkSendTemplateMessageLimit.data.limit }}</p>
          <div
            v-if="showSuccessMessage && uniqueContactsCount < 2"
            class="success-info">
            Notification has been successfully sent.
          </div>
          <div
            v-if="showSuccessMessage && uniqueContactsCount >= 2"
            class="success-info">
            Campaign has been successfully sent.
          </div>
          <div
            v-if="errorMessage"
            class="error-message">
            {{ errorMessage }}
          </div>
          <span
            id="disabled-send-wrapper"
            class="d-inline-block mt-3 mb-5">
            <b-button
              :class="{loading: saving}"
              :disabled="saving || uniqueContactsCount > whatsappBulkSendTemplateMessageLimit.data.limit || (!hasBulkSendPermission && uniqueContactsCount > 1)"
              class="btn-round btn-save"
              @click="submitMessage">
              <span v-if="!saving">Send</span>
              <div class="loader"><div class="loading-circle"/></div>
            </b-button>
            <div
              v-if="!hasBulkSendPermission && uniqueContactsCount > 1"
              class="error-message pl-0">
              You do not have permission to send a campaign.
            </div>
          </span>
          <b-tooltip
            v-if="uniqueContactsCount > whatsappBulkSendTemplateMessageLimit.data.limit"
            target="disabled-send-wrapper"
            placement="right">Selected number of contacts exceeds max daily limit.</b-tooltip>
        </b-col>
        <b-col
          md="12"
          lg="5"
          class="px-0 float-left">
          <div class="phone-mockup">
            <div class="phone-display scroll-area">
              <div class="message-container">
                <div class="inbound">
                  <p :class="{'text-arabic': selectedTemplateLanguage === 'ar'}">
                    <MessageContent
                      :content="message"
                      :detect-urls="true"/>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </div>
      <div
        v-if="!templateMessagesLoaded"
        class="loader loader-main">
        <div class="loading-circle"/>
      </div>
      <div
        v-else-if="!templateKeywords.length"
        class="content-unavailable">
        <img src="~@/assets/img/whatsapp-splash.svg">
        <h4>You haven’t created any template messages.</h4>
        <p>Create template messages in order to send notifications.</p>
      </div>
    </div>
    <div
      v-if="!tagInputsReady"
      class="overlay">
      <div
        class="loader">
        <div class="loading-circle"/>
      </div>
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
.c-dropdown-item {
  text-transform: capitalize;
}

#notification-send-modal {
  .overlay {
    display: flex;
    background: white;
    opacity: 0.5;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;
    z-index: 100;
  }

  .unique-info {
    font-size: 14px;
    .strong {
      font-weight: 600;
    }
  }

  .loader.unique {
    display: inline-flex;
    height: auto;
    width: auto;

    .loading-circle {
      margin: 0 auto;
      width: 14px;
      height: 14px;
      border: 2px solid transparent;

      &:before {
        width: 14px;
        height: 14px;
        left: -2px;
        top: -2px;
        border: 2px solid rgba($black, 0.15);
        border-top-color: $black;
      }
    }
  }

  .editor-tag {
    position: relative;
    padding: 0px 7px!important;
    border: 1px solid #30343a;
    border-radius: 20px;
    background: rgba(61, 139, 252, 0.05);
    color: #30343a;
    font-weight: 400;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-transform: capitalize;
    text-overflow: ellipsis;
    outline: none;
  }

  .tags-group input.fixed {
    height: 34px;
  }
}
</style>

<script>
import '@/assets/css/modules/_notification-send-form.scss';

import { mapActions, mapGetters } from 'vuex';
import { position } from 'caret-pos';
import ClickOutside from 'v-click-outside';
import setValidationErrors from '@/helpers/validationErrors';
import getLanguageName from '@/helpers/getLanguageName';
import MessageContent from '../../../common/MessageContent';
import ContactSearch from '../partials/ContactSearch';
import DropZone from '../../../common/DropZone';
import { getMediaName } from '../../../../helpers/mediaHelpers';

require('../../../../assets/js/emojioneArea');

export default {
  name: 'NotificationSendModal',
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  components: {
    MessageContent,
    ContactSearch,
    DropZone,
  },
  props: {
    contactp: {
      type: Object,
      default: () => {},
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      manualSetContact: {},
      bulkIds: {},
      selectedTemplateKeyword: '',
      selectedTemplateSet: [],
      languageList: [],
      selectedTemplate: {},
      selectedTemplateLanguage: '',
      tagsToSend: {},
      validationErrors: {},
      showSuccessMessage: false,
      errorMessage: '',
      showTagsList: {},
      caretPosition: 0,
      showTagListFor: '',
      reinitializeTagsInputFields: false,
      tagInputsReady: false,
      files: [],
      formData: new FormData(),
      sendAgainFile: null,
    };
  },
  computed: {
    ...mapGetters({
      // merchantName: 'merchant/merchantName',
      // agentName: 'user/name',
      // agentFirstName: 'user/firstName',
      templateMessageList: 'notification/templateMessageList',
      templateMessagesLoaded: 'notification/templateMessagesLoaded',
      templateMessageSent: 'notification/templateMessageSent',
      bulkMessagesSent: 'notification/bulkMessagesSent',
      apiError: 'notification/apiError',
      merchant: 'merchant/merchant',
      calculatingUniqueContacts: 'contact/calculatingUniqueContacts',
      uniqueContactsCount: 'contact/uniqueContactsCount',
      notificationTags: 'notification/notificationTags',
      notificationTagsLoaded: 'notification/notificationTagsLoaded',
    }),
    hasTemplateMessages() {
      return this.templateMessagesLoaded && this.templateKeywords.length;
    },
    // templateKeywords() {
    //   let templateKeywords = [];
    //   Object.keys(this.templateMessageList).forEach( templateKey => {
    //     if (this.templateMessageList[templateKey].some( templateLang => templateLang.status === 'approved' )) {
    //       templateKeywords.push(templateKey);
    //     };
    //   });

    //   return templateKeywords;
    // },
    // messageTagValues() {
    //   return {
    //     business_name: this.merchantName,
    //     contact_name: this.contact.name,
    //     agent_first_name: this.agentFirstName,
    //     agent_name: this.agentName,
    //   };
    // },
    hasBulkSendPermission() {
      return this.$hasPermissionInOrganisation('send_bulk_messages');
    },
    message() {
      let message = this.selectedTemplate.text || '';
      this.$lodash.forEach(this.tagsToSend, (tagValue, keyword) => {
        if (tagValue !== '') {
          message = message.replace(new RegExp(`\\{\\{${keyword}\\}\\}`, 'g'), tagValue);
        }
      });

      return message;
    },
    whatsappBulkSendTemplateMessageLimit() {
      return this.merchant.extra_features.find(feature => feature.key === 'whatsapp-bulk-send-template-message') || { data: { limit: 0 } };
    },
    /** Prepares the tags to be used on the template. */
    normalizedNotificationTags() {
      const normalizedTags = this.notificationTags.map(tag => ({
        name: tag.replace('_', ' '),
        keyword: tag,
      }));

      return normalizedTags;
    },
  },
  watch: {
    contactp(contact) {
      this.setRecipients({ contacts: [contact] });
    },
    // templateMessagesLoaded(loaded) {
    //   if (loaded && this.templateKeywords.length) {
    //     this.selectedTemplateKeyword = this.templateKeywords[0];
    //   }
    // },
    selectedTemplateKeyword(keyword) {
      this.selectedTemplateSet = this.templateMessageList[keyword];
    },
    selectedTemplateSet(templateSet) {
      this.clearFile();
      this.languageList = templateSet.filter(set => set.status == 'approved').map(set => set.language);
      this.selectedTemplate = templateSet[0];
      this.selectedTemplateLanguage = this.selectedTemplate.language;
      this.tagInputsReady = false;
      this.tagsToSend = {};
      this.validationErrors = {};
      this.errorMessage = '';
      this.saving = false;
      setTimeout(() => {
        this.reinitializeTagsInputFields = true;
      });
    },
    selectedTemplateLanguage(language) {
      this.selectedTemplate = this.$lodash.find(this.selectedTemplateSet, template => template.language === language);
    },
    templateMessageSent(messageSid) {
      if (messageSid) {
        this.saving = false;
        this.showSuccessMessage = true;

        this.$emit('sent', {
          contact_id: this.manualSetContact.id,
          sid: messageSid,
          text: this.message,
        });

        this.closeModal(2000);
      }
    },
    bulkMessagesSent(bulkSendUUID) {
      if (bulkSendUUID) {
        this.saving = false;
        this.showSuccessMessage = true;
        this.$emit('bulkSent', {
          bulkSendUUID,
        });

        // Subscribe to bulk send stats
        // this.subscribeToBulkSendStats({
        //   bulkSendUUID,
        //   merchantId: this.$route.params.merchant_id,
        // });

        this.closeModal(2000);
      }
    },
    apiError(error) {
      this.saving = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
    // selectedTemplate() {
    //   this.selectedTemplate.tags.forEach((tag) => {
    //     this.$set(this.tagsToSend, tag, this.messageTagValues[tag] || '');
    //   });
    // },
    bulkIds(newValue) {
      const payload = {
        bulkIds: newValue,
        merchantId: this.$route.params.merchant_id,
        status: 'subscribed',
        channel: 'whatsapp',
      };
      if (newValue.tags && newValue.contacts) {
        this.countUniqueContacts(payload);
      }
    },
    /** Initiates the render of input fields. */
    reinitializeTagsInputFields() {
      this.reinitializeTagsInputFields = false;
      this.initializeTagInputFieldsAsEmojiOneArea();
    },
  },
  mounted() {
    this.fetchTemplateMessages(this.$route.params.merchant_id);
    // this.loadAvailableNotificationTags(this.$route.params.merchant_id);
  },
  methods: {
    ...mapActions({
      fetchTemplateMessages: 'notification/fetchTemplateMessages',
      sendTemplateMessage: 'notification/sendTemplateMessage',
      countUniqueContacts: 'contact/countUniqueContacts',
      // subscribeToBulkSendStats: 'pusher/subscribeToBulkSendStats',
      resetUniqueContactCount: 'contact/resetUniqueContactCount',
      loadAvailableNotificationTags: 'notification/loadAvailableNotificationTags',
    }),
    getMediaName,
    getLanguageName,
    onShow() {
      this.tagInputsReady = false;
      if (this.manualSetContact && this.manualSetContact.contacts && this.manualSetContact.contacts.length) {
        this.manualSetContact.contacts.forEach((contact) => {
          this.$refs.contactSearch.setContact(contact);
        });
      }
      if (this.manualSetContact && this.manualSetContact.tags && this.manualSetContact.tags.length) {
        this.manualSetContact.tags.forEach((tag) => {
          this.$refs.contactSearch.setTag(tag);
        });
      }
      setTimeout(() => {
        this.reinitializeTagsInputFields = true;
      });
    },
    closeModal(delay) {
      setTimeout(() => {
        this.showSuccessMessage = false;
        this.hide();
      }, delay);
    },
    /** Converts inputs to emojione inputs. */
    initializeTagInputFieldsAsEmojiOneArea() {
      const vue = this;
      Object.keys(this.$refs).forEach((key) => {
        if (key.startsWith('tagArea-')) {
          if (this.$refs[key][0] && !this.$refs[key][0].$el.emojioneArea) {
            window.$(this.$refs[key][0].$el).emojioneArea({
              pickerPosition: 'bottom',
              filtersPosition: 'bottom',
              tones: false,
              autocomplete: false,
              hidePickerOnBlur: true,
              saveEmojisAs: 'unicode',
              parseTags: true,
              events: {
                keyup() {
                  vue.updateMessageValues(key);
                },
                emojibtn_click() {
                  vue.updateMessageValues(key);
                },
              },
            });

            window.$(this.$refs[key][0].$el.emojioneArea.editor[0]).focusout(() => {
              this.caretPosition = position(this.$refs[key][0].$el.emojioneArea.editor[0]).pos;
            });
          }
        }
      });

      this.tagInputsReady = true;
    },
    setRecipients(data) {
      this.manualSetContact = data;
    },
    setTemplate(template, tags) {
      this.selectedTemplateKeyword = template.keyword;
      this.$nextTick(() => {
        this.selectedTemplateLanguage = template.language;

        if (tags) {
          this.selectedTemplate.tags.forEach((tag) => {
            this.$set(this.tagsToSend, tag, tags[tag] || '');
          });
        }

        if (template.attachment) {
          this.sendAgainFile = template.attachment;
          this.formData.set('attachment', template.attachment);
        }
      });
    },
    submitMessage() {
      this.validationErrors = {};
      this.errorMessage = '';
      const sendData = {};

      Object.keys(this.tagsToSend).forEach((tag) => {
        sendData[tag] = this.tagsToSend[tag].replace(/!!!(.*?)!!!/g, '{{$1}}');
      });

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.saving = true;
          this.formData.set('bulk', JSON.stringify(this.bulkIds));
          this.formData.set('keyword', this.selectedTemplateKeyword);
          this.formData.set('language', this.selectedTemplateLanguage);
          this.formData.set('tags', JSON.stringify(sendData));
          const payload = {
            merchant_id: this.activeConversation.business_id,
            conversation_id: this.activeConversation.id,
            data: this.formData,
          };

          this.sendTemplateMessage(payload);
        }
      });
    },
    show() {
      this.$refs.notificationSendModal.show();
    },
    hide() {
      this.saving = false;
      this.bulkIds = {};
      this.$refs.notificationSendModal.hide();
    },
    resetData() {
      this.clearFile();
      if (this.hasTemplateMessages) {
        this.selectedTemplateKeyword = this.templateKeywords[0];
        this.selectedTemplateLanguage = this.languageList[0];
        this.tagsToSend = {};
        this.validationErrors = {};
        this.errorMessage = '';
        this.saving = false;
        // Only clear the manual set contact if it is not fixed on the modal like it is from the messages component.
        if (!this.fixed) {
          this.manualSetContact = {};
        }
      }
      this.resetUniqueContactCount();
    },
    /** Shows the tags list for the selected field. */
    toggleTagsList(tagRef) {
      this.showTagsList[tagRef] = this.showTagsList[tagRef] ? !this.showTagsList[tagRef] : true;
      this.showTagListFor = tagRef;
    },
    /** Hides the tag list for fields which are not in the focus any more. */
    hideTagsList() {
      Object.keys(this.showTagsList).forEach((key) => {
        if (key !== this.showTagListFor) {
          this.showTagsList[key] = false;
        }
      });
      this.showTagsList = { ...this.showTagsList };

      setTimeout(() => {
        this.showTagListFor = '';
      });
    },
    /** adds the tag to the field. */
    setTag(tag, tagRef) {
      if (!window.$(this.$refs[tagRef][0].$el.emojioneArea.editor[0]).is(':focus')) {
        this.stayFocused(tagRef);
      }

      const tagTemplate = `<input type="button" class="editor-tag ellipsis" data-name="{{${tag.keyword}}}" value="${tag.name}"/>&nbsp;`;

      this.$refs[tagRef][0].$el.emojioneArea.pasteHtmlAtCaret(tagTemplate);
      this.hideTagsList();

      this.updateMessageValues(tagRef);
    },
    /** Focuses the right field to input tag. */
    focus(tagRef) {
      this.$refs[tagRef][0].$el.emojioneArea.editor.focus();
    },
    /** Sets the focus and position to the right field. */
    stayFocused(tagRef) {
      this.focus(tagRef);
      position(this.$refs[tagRef][0].$el.emojioneArea.editor[0], this.caretPosition);
    },
    /** Sets the values for the template to be sent. */
    updateMessageValues(tagRef) {
      const tag = tagRef.replace('tagArea-', '');
      const escapeTags = this.$refs[tagRef][0].$el.emojioneArea.getText().replace(/\{\{(.*?)\}\}/g, '!!!$1!!!');
      this.$set(this.tagsToSend, tag, escapeTags || '');
    },
    fileDropped(file) {
      if (file) {
        this.formData.set('file', file[0]);
      }
    },
    clearFile() {
      this.formData.delete('file');
      this.formData.delete('attachment');
      this.sendAgainFile = null;
      this.files = [];
    },
  },
};
</script>
